import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import '../contact-manager.css'
import { useTranslations } from '../providers/ContactServiceProvider'

const SKELETON_ROWS = 3

interface ContactGridSkeletonProps {
  layout?: 'table' | 'card'
}

export function ContactGridSkeleton({ layout = 'table' }: ContactGridSkeletonProps) {
  const t = useTranslations()

  if (layout === 'card') {
    return (
      <div className="contact-grid-skeleton flex flex-col gap-3">
        {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
          <div key={i} className="rounded-md bg-white p-4 shadow-sm dark:bg-slate-900">
            <Skeleton width={160} height={16} />
            <Skeleton width={200} height={14} className="mt-1" />
            <Skeleton width={120} height={12} className="mt-1" />
          </div>
        ))}
      </div>
    )
  }

  return (
    <table className="contact-grid-skeleton w-full">
      <thead>
        {/* Same header color/weight as ContactGrid's own loaded table (text-content-primary,
            font-semibold) — this used to be text-slate-500, a washed-out gray that stayed
            visible only for the brief loading flash, but read as inconsistent with the real
            headers that replace it right after. */}
        <tr className="border-b border-border-primary dark:border-dark-border-primary">
          <th className="py-3 px-4 text-left text-sm font-semibold text-content-primary dark:text-dark-content-primary">{t.skeleton.column.name}</th>
          <th className="py-3 px-4 text-left text-sm font-semibold text-content-primary dark:text-dark-content-primary">{t.skeleton.column.email}</th>
          <th className="py-3 px-4 text-left text-sm font-semibold text-content-primary dark:text-dark-content-primary">{t.skeleton.column.phone}</th>
          <th className="py-3 px-4 text-right text-sm font-semibold text-content-primary dark:text-dark-content-primary">{t.skeleton.column.actions}</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
          <tr key={i} className="border-b border-border-secondary dark:border-dark-border-primary">
            <td className="py-3 px-4"><Skeleton width={140} /></td>
            <td className="py-3 px-4"><Skeleton width={180} /></td>
            <td className="py-3 px-4"><Skeleton width={120} /></td>
            <td className="py-3 px-4 text-right"><Skeleton width={80} /></td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
